import config from '../config';
import Vue from 'vue';

import { getUrlParam, getLoginIndex, clearLocalStorage } from './utils';
import { errorCode } from './errorCode';
import { setItem, getItem, removeItem, cookieManager } from './utils';
import { apiData } from './dataService';
import installPermission from './installPermission';
import store from '../store/index';
import htmlOptions from '../../config/html';

class userService {
  async login(payload, vue) {
    let [_self, redirect] = [vue, getUrlParam('redirect')];
    try {
      const resp = await apiData('post', payload.url, payload.payload);
      let query = decodeURIComponent(redirect);
      _self.setItem('local', 'twe_logged', resp.token);
      if (resp.needSetPwd) {
        _self.$router.push('/setPassword');
        _self.setItem(
          'local',
          'setPwdUser',
          JSON.stringify({ email: resp.email, showVerify: 1 })
        );
        return;
      }
      const ret = await vue.fetchAccount();
      removeItem('local', 'closeBroad');
      store._actions.getBroadCast[0]();
      vue.RegistCall();
      installPermission(Vue, ret);
      window.sa.login(resp.userid);
      //登录赋值日查 没有额度
      _self.$store.commit('setClickNum', {
        clickcontact_volume: resp.clickcontact_volume,
        clickedContacts: resp.clickedContacts
      });
      _self.keepName
        ? cookieManager.setItem(
            config.cookie.userKey,
            payload.payload.username,
            15
          )
        : cookieManager.removeItem(config.cookie.userKey);
      //判断是否需要提示主账户子账户停用
      if (resp.blockedSubNotice) {
        let blockedSubNotice = resp.blockedSubNotice;
        _self.setItem(
          'local',
          'blockedSubNotice',
          JSON.stringify(blockedSubNotice)
        );
      }
      if (redirect) {
        /* 跳转至相应的链接 */
        window.location.href = query;
        // _self.$router.push({path:query});
      } else {
        _self.$router.push({
          path: getLoginIndex(resp.role)
        });
      }
    } catch (error) {
      vue.$message({
        type: 'error',
        message: error.message_local
          ? error.message_local
          : errorCode[error.error_code]
        // customClass: 'login-message'
      });
      vue.buttonMsg = '登录系统';
      vue.disable = false;
    }
  }
  async tokenLogin(vue, token, redirect) {
    try {
      setItem('local', 'twe_logged', token);
      const resp = await vue.$store.dispatch('fetchAccount');
      removeItem('local', 'closeBroad');
      vue.RegistCall();
      if (resp.role == 'guest') {
        Vue.prototype.role = 'guest';
        if (redirect) {
          redirect = window.decodeURIComponent(redirect);
          vue.$router.push(redirect);
        }
        return;
      }
      if (resp.agent_type == '5') {
        if (!resp.status && resp.token) {
          //未激活用户去激活
          if (__VERSION === 'HQ') {
            vue.$router.push('/welcome?redirect=' + redirect);
          } else {
            vue.$router.push('/welcome');
          }
        } else {
          if (resp.disable == true && resp.status == 1) {
            clearLocalStorage();
            vue.$message.error('该账户已被冻结');
            window.setTimeout(() => {
              window.location.href = '/login';
            }, 1000);
            return;
          }
          if (resp.logon_status && resp.logon_status != 1) {
            clearLocalStorage();
            if (__VERSION === 'HQ') {
              vue.$router.push('/error');
            } else {
              window.setTimeout(() => {
                window.location.href = '/login';
              }, 1000);
            }
            switch (resp.logon_status) {
              case 2:
                vue.$message.error('上级账户未激活');
                return;
              case 3:
                vue.$message.error('该账户的上级账户已失效或冻结');
                return;
              case 4:
                vue.$message.error('账户已过期');
                return;
              default:
                break;
            }
            return;
          }
          installPermission(Vue, resp);
          vue.$store.commit('setClickNum', {
            clickcontact_volume: resp.clickcontact_volume,
            clickedContacts: resp.clickedContacts
          });
          if (redirect) {
            redirect = window.decodeURIComponent(redirect);
            vue.$router.push(redirect);
          } else {
            vue.$router.push('/search');
          }
          store._actions.getBroadCast[0]();
        }
      } else {
        installPermission(Vue, resp);
        window.sa.login(resp.userid);
        vue.$store.commit('setClickNum', {
          clickcontact_volume: resp.clickcontact_volume,
          clickedContacts: resp.clickedContacts
        });
        vue.$router.push({
          path: getLoginIndex(resp.role)
        });
        store._actions.getBroadCast[0]();
      }
    } catch (error) {
      console.log(error);
      if (error.error_code === 1067) {
        vue.setItem('local', 'twe_logged', token);
        vue.$router.push('/setPassword');
        vue.setItem('local', 'setPwdUser', JSON.stringify({ showVerify: 1 }));
        return;
      }
      vue.$router.push('/error');
    }
  }

  logout(code, vue) {
    return new Promise((resolve, reject) => {
      let user = null;
      let userStr = getItem('local', 'twe_userInfo');
      if (userStr) {
        user = JSON.parse(userStr);
      }
      clearLocalStorage();
      removeItem('session', 'search');
      removeItem('session', 'welcome');
      removeItem('session', 'callRegisted');
      removeItem('session', 'delNoContact');
      window.sa.logout();
      store._actions.getUpdateName[0]();
      if (user && user.logoutDomain) {
        window.location.href = user.logoutDomain;
      } else {
        if (code == 401 || code == 403) {
          setTimeout(function() {
            window.location.href = '/login';
          }, 1000);
        } else {
          window.location.reload();
          window.location.href = '/login';
        }
      }

      resolve();
    });
  }
}
export default new userService();



// WEBPACK FOOTER //
// ./src/common/user.js